<template>
  <div class="root">
    <div class="title">卡积分购买</div>
    <div class="balance">
      <span class="text-1">当前积分：</span><span class="text-2"> {{stockInfo.balance}}</span>
    </div>
    <div class="list">
      <div class="list-title">积分购买</div>
      <div class="box">
          <div class="box-item" v-for="(item,key) in packageList" :key="item.id" :class="packageID==item.id?'active':''"  @click="checkPackage(item)">
            <div class="text-1"><span>{{item.integral}}</span><span>积分</span></div>
            <div class="text-2">{{item.price}}元</div>
          </div>
      </div>
    </div>
    <div class="btn" @click="createOrder">购买</div>
  </div>
</template>

<script>
export default {
  name: "recharge",
  data () {
    return {
      iccid: "",
      packageID: 0,
      packageList: [],
      one: {},
      stockInfo: {}
    }
  },
  methods: {
    queryPackageList () {
      this.$toast.loading()
      this.fetchData("/package/cardBalancePackage", {iccid: this.iccid}, (res) => {
        this.$toast.clear()
        if (res.code) {
          this.packageList = res.data
        } else {
          this.$toast.fail(res.msg)
          this.packageList = []
        }
      })
    },
    checkPackage (item) {
      this.packageID = item.id
      this.one = item
    },
    createOrder () {
      this.commitorder()
    },
    commitorder () {
      this.$toast.loading()
      this.fetchDataPost("/order/createBalanceOrder", {
        iccid: this.iccid,
        packageID: this.packageID,
      }, (res) => {
        this.$toast.clear()
        if (res.code) {
          WeixinJSBridge.invoke(
            "getBrandWCPayRequest", res.data,
            (res) => {
              if (res.err_msg == "get_brand_wcpay_request:ok") {
                this.$toast.success("支付成功")
                this.$router.back()
              }
            }
          )
        } else {
          if (res.url) {
            this.$dialog.confirm({
              title: "提示",
              message: res.msg
            }).then(() => {
              // on confirm
              let query = {}
              if (res.data) {
                query = res.data
              }
              query.cardno = this.iccid
              this.$router.push({path: res.url, query: query})
            }).catch(() => {
              // on cancel
            })
          } else {
            if (res.msg.indexOf("appid") !== -1 && res.msg.indexOf("openid") !== -1) {
              this.$toast.fail("登录失效，请尝试重新进入查询")
              sessionStorage.clear()
            } else {
              this.$toast.fail(res.msg)
            }
          }
        }
      })
    },
    getStockInfo () {
      this.fetchData("/card/info", {iccid: this.iccid}, (res) => {
        this.stockInfo = res.data
        if(this.stockInfo.rechargeType!=1){
          this.$dialog({message:"此设备不是积分充值类型"}).then(res=>{
            this.$router.back()
          })
        }else {
          this.queryPackageList()
        }
      })
    }
  },
  created: function () {
    let query = this.$route.query
    this.iccid = query.iccid
    this.getStockInfo()

  }
}
</script>
<style lang="scss" scoped>
.root{
  .btn{
    width: 2.1rem;
    height: .76rem;
    line-height: .76rem;
    text-align: center;
    font-size: .32rem;
    font-weight: bold;
    color: #0581ff;
    margin: 1rem auto 0;
    background: #fff;
    letter-spacing: .12rem;
    text-indent: .12rem;
  }
  height: inherit;
  font-size: 0;
  background: linear-gradient(180deg, #fc8688,#f05964);
  overflow-y: scroll;
  .list{
    margin: .3rem auto;
    width: 6rem;
    .list-title{
      font-size: .32rem;
      text-indent: .14rem;
      letter-spacing: .06rem;
    }
    .box{
      width: 100%;
      margin: 0 auto;
      .box-item:nth-child(3n+1){
        margin-left: 0;
      }
      .box-item{
        width: 1.8rem;
        display: inline-block;
        text-align: center;
        font-size: .28rem;
        background: #fff;
        margin-left: .3rem;
        margin-top: .3rem;
        padding: .06rem 0;
        border-radius: .1rem;
        .text-1{
          color: #0581ff;
          letter-spacing:.01rem;
          text-indent:.01rem;
          :last-child{
            font-size: .2rem;
            margin-left: .1rem;
          }
        }
        .text-2{
          color: #000;
          margin-top: .06rem;
        }
      }
      .box-item.active{
        box-shadow: 0 0 0 2px #0581ff;
      }
    }
  }
  .balance {
    width: 5rem;
    background: #fff;
    text-align: center;
    padding: .12rem 0;
    margin: .3rem auto 0;
    border-radius: .1rem;
    .text-1 {
      font-size: .30rem;
      letter-spacing: .2rem;
    }

    .text-2 {
      font-size: .3rem;
      color: #3690e3;
      font-weight: bold;
    }
  }
  .title{
    font-size: .36rem;
    text-align: center;
    color: #fff;
    padding: .2rem 0 ;
    letter-spacing: .1rem;
    background: #f05964;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/cardbalance.vue